module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._c;
  return _c('section', {
    staticClass: "cover"
  }, [_c('div', {
    staticClass: "cover-inner"
  }, [_c('img', {
    staticClass: "cover-pic",
    attrs: {
      "src": require("../assets/coding.png")
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "cover-description"
  }, [_c('div', {
    staticClass: "cover-description-title"
  }, [_vm._v("\n        " + _vm._s(_vm.name) + "\n        "), _c('br'), _vm._v("\n        Leetcode Solutions\n      ")]), _vm._v(" "), _c('div', {
    staticClass: "cover-description-content"
  }, [_vm._v("\n        " + _vm._s(_vm.language === 'en' ? "This website presents all my accepted Leetcode solutions." :
    "这个网页呈现了我全部的Leecode解题源码.") + "\n        "), _c('br'), _vm._v("\n        " + _vm._s(_vm.language === 'en' ? "I've solved" : "我完成了 ") + "\n        "), _c('pulse-out-loader', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.loading),
      expression: "loading"
    }],
    staticStyle: {
      "display": "inline-block"
    }
  }), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.loading),
      expression: "!loading"
    }],
    staticClass: "green"
  }, [_vm._v(_vm._s(_vm.solved))]), _vm._v(" / "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.loading),
      expression: "!loading"
    }],
    staticClass: "green"
  }, [_vm._v(_vm._s(_vm.total))]), _c('pulse-out-loader', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.loading),
      expression: "loading"
    }],
    staticStyle: {
      "display": "inline-block"
    }
  }), _vm._v("\n        " + _vm._s(_vm.language === 'en' ? "problems" : "道题") + " (" + _vm._s(_vm.language === 'zh' ? "有" : "") + " " + _vm._s(_vm.locked) + " " + _vm._s(_vm.language === 'en' ? "problems for a fee" : "题需要付费") + ").\n        "), _c('br'), _vm._v("\n        " + _vm._s(_vm.language === 'en' ? "Click" : "") + " "), _c('router-link', {
    attrs: {
      "to": "/source"
    }
  }, [_vm._v(_vm._s(_vm.language === 'en' ? "here" : "点此"))]), _vm._v(" " + _vm._s(_vm.language === 'en' ? "to see every solution" : "查看每一个解题源码") + ".\n        "), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "light"
  }, [_vm._v("Last updated: "), _c('pulse-out-loader', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.loading),
      expression: "loading"
    }],
    staticStyle: {
      "display": "inline-block"
    }
  }), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.loading),
      expression: "!loading"
    }],
    staticClass: "green"
  }, [_vm._v(_vm._s(_vm.lastUpdatedTime))])])])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-3af4f0cf!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Cover.vue
// module id = 124
// module chunks = 2